export const TOTAL_BUSINESS_MODEL_HEADERS = [
  "Futures Total",
  "At Once Total",
  "Overall Total",
];
